import React from 'react';
import { Icons } from '@ublend-npm/aulaui-core';
import ManageWidget from './widgets/manageWidget';
import MessagesWidget from './widgets/messagesWidget';
import StarredSpacesWidget from './widgets/starredSpacesWidget';
import RecentlyViewedSpacesWidget from './widgets/recentlyViewedSpacesWidget/RecentlyViewedSpacesWidget';
import RecentUpdates from './widgets/RecentUpdates';
import UpcomingAssignmentsWidget from './widgets/upcomingAssignmentsWidget';
import QuickLinks from './widgets/quickLinksWidget';
import OutlookWidget from './widgets/outlookWidget';
import { WidgetLayoutProfile } from './layout/widgetLayout.types';
import {
  LinkOutlined,
  HistoryOutlined,
  MailOutline,
} from '@mui/icons-material';

export const HOME_SPACES_WIDGET_IDS = [
  'home-switchrole-widget',
  'home-greeting-widget',
  'home-space-widget',
] as const;

export type HomeWidgetDefinition = {
  id: string;
  component: React.ReactNode;
  icon: React.ReactNode;
  title: string;
  ariaLabel?: string;
  layout: WidgetLayoutProfile;
  size?: Record<string, number>;
};

const widgetsLibrary: HomeWidgetDefinition[] = [
  {
    id: 'home-switchrole-widget',
    component: null,
    icon: <Icons.AssignmentOutlined fontSize="small" />,
    title: 'Switch Role',
    layout: {
      zone: 'hero',
      visibility: 'fixed',
      sizeProfile: 'card',
      colSpan: { xs: 12 },
      order: 0,
    },
    size: { lg: 12, md: 12, xs: 12 },
  },
  {
    id: 'home-greeting-widget',
    component: null,
    icon: <Icons.AssignmentOutlined fontSize="small" />,
    title: 'Greeting',
    ariaLabel: 'Greeting Widgets',
    layout: {
      zone: 'hero',
      visibility: 'fixed',
      sizeProfile: 'card',
      colSpan: { xl: 2, lg: 2, xs: 12 },
      order: 1,
    },
    size: { lg: 2, md: 12, xs: 12 },
  },
  {
    id: 'home-space-widget',
    component: null,
    icon: <Icons.AssignmentOutlined fontSize="small" />,
    title: 'Space',
    ariaLabel: 'Space Widget',
    layout: {
      zone: 'hero',
      visibility: 'fixed',
      sizeProfile: 'wide',
      colSpan: { xl: 7, lg: 6, xs: 12 },
      order: 2,
    },
    size: { lg: 10, md: 12, xs: 12 },
  },
  {
    id: 'home-messages-widget',
    component: <MessagesWidget />,
    icon: <Icons.ChatOutlined fontSize="small" />,
    title: 'Messages',
    layout: {
      zone: 'main',
      visibility: 'hideable',
      sizeProfile: 'card',
      colSpan: { xl: 3, lg: 4, md: 7, sm: 12, xs: 12 },
      order: 10,
    },
    size: { lg: 4, md: 6, xs: 12 },
  },
  {
    id: 'home-outlook-widget',
    component: <OutlookWidget />,
    icon: <MailOutline fontSize="small" />,
    title: 'Outlook',
    layout: {
      zone: 'main',
      visibility: 'hideable',
      sizeProfile: 'card',
      colSpan: { xl: 3, lg: 4, md: 7, sm: 12, xs: 12 },
      order: 15,
    },
    size: { lg: 4, md: 6, xs: 12 },
  },
  {
    id: 'home-upcoming-assignments-widget',
    component: <UpcomingAssignmentsWidget />,
    icon: <Icons.AssignmentOutlined fontSize="small" />,
    title: 'Upcoming assignments',
    layout: {
      zone: 'main',
      visibility: 'hideable',
      sizeProfile: 'card',
      colSpan: { xl: 3, lg: 4, md: 7, sm: 12, xs: 12 },
      order: 20,
    },
    size: { lg: 4, md: 6, xs: 12 },
  },
  {
    id: 'home-recently-viewed-spaces-widget',
    component: <RecentlyViewedSpacesWidget />,
    icon: <HistoryOutlined fontSize="small" />,
    title: 'Recently viewed spaces',
    layout: {
      zone: 'main',
      visibility: 'hideable',
      sizeProfile: 'card',
      colSpan: { xl: 3, lg: 4, md: 7, sm: 12, xs: 12 },
      order: 30,
    },
    size: { lg: 4, md: 6, xs: 12 },
  },
  {
    id: 'home-starred-spaces-widget',
    component: <StarredSpacesWidget />,
    icon: <Icons.StarBorder fontSize="small" />,
    title: 'Starred spaces',
    layout: {
      zone: 'main',
      visibility: 'hideable',
      sizeProfile: 'card',
      colSpan: { xl: 3, lg: 4, md: 7, sm: 12, xs: 12 },
      order: 40,
    },
    size: { lg: 4, md: 6, xs: 12 },
  },
  {
    id: 'home-manage-widget',
    component: <ManageWidget />,
    icon: <Icons.AssignmentOutlined fontSize="small" />,
    title: 'Manage widgets',
    layout: {
      zone: 'main',
      visibility: 'fixed',
      sizeProfile: 'card',
      colSpan: { xl: 3, lg: 4, md: 7, sm: 12, xs: 12 },
      order: 100,
    },
    size: { lg: 4, md: 6, xs: 12 },
  },
  {
    id: 'home-recent-updates-widget',
    component: <RecentUpdates />,
    icon: <Icons.AssignmentOutlined fontSize="small" />,
    title: 'Recent Updates',
    layout: {
      zone: 'sidebar',
      visibility: 'fixed',
      sizeProfile: 'long',
      colSpan: { xl: 3, lg: 4, md: 5, xs: 12 },
      order: 5,
    },
    size: { xl: 3, lg: 4, md: 5, sm: 12, xs: 12 },
  },
  {
    id: 'home-quick-links-widget',
    component: <QuickLinks />,
    icon: <LinkOutlined fontSize="small" />,
    title: 'Quick links',
    layout: {
      zone: 'main',
      visibility: 'hideable',
      sizeProfile: 'card',
      colSpan: { xl: 4, lg: 8, md: 6, sm: 12, xs: 12 },
      order: 50,
    },
  },
];

export default widgetsLibrary;
